import { GlobalIcon } from "get-life-storybook-ts";
import {
  NewCheckoutI,
  PurchasePeriodT,
} from "../../../../../../api/request/Lead/Interfaces/DataInterface.response";
import { numberFormatPayment } from "../../../../../../utils/Utils";
import { PricesV3T } from "../types";

interface FreqCardsProps {
  checkout: NewCheckoutI;
  prices?: PricesV3T;
  translate: (key: string) => string;
  handlePurchasePeriod: (value: PurchasePeriodT) => void;
  variant?: "default" | "compact";
}

const FreqCards = ({
  checkout,
  prices,
  translate,
  handlePurchasePeriod,
  variant = "default",
}: FreqCardsProps) => {
  const period = (checkout.period?.toLowerCase() || "monthly") as
    | "monthly"
    | "yearly";

  return (
    <div className={`paymentV3FreqCards paymentV3FreqCards--${variant}`}>
      {(["yearly", "monthly"] as const).map((id) => {
        const active = period === id;
        const isYearlyCard = id === "yearly";
        const cardPrices = isYearlyCard ? prices?.yearly : prices?.monthly;
        const baseFull =
          cardPrices?.real ??
          (isYearlyCard ? checkout.finalYearlyPrice : checkout.regularPrice);
        const baseNow =
          cardPrices?.promoted ??
          (isYearlyCard
            ? checkout.feeCollection?.find((f) => f.frecuency === "YEARLY")
                ?.total ?? checkout.finalYearlyPrice
            : checkout.priceToPay);
        const cardDiscounted = baseNow < baseFull;
        return (
          <button
            key={id}
            type="button"
            onClick={() => handlePurchasePeriod(id as PurchasePeriodT)}
            className={`paymentV3FreqCards__card ${
              active ? "paymentV3FreqCards__card--active" : ""
            }`}
          >
            <span className="paymentV3FreqCards__label">
              {translate(
                isYearlyCard
                  ? "paymentV3.summary.freq.annual"
                  : "paymentV3.summary.freq.monthly"
              )}
            </span>
            {cardDiscounted && (
              <span className="paymentV3FreqCards__oldPrice">
                {numberFormatPayment(baseFull)} €
              </span>
            )}
            <span className="paymentV3FreqCards__price">
              {numberFormatPayment(baseNow)} €
            </span>
            <span className="paymentV3FreqCards__sub">
              {translate(
                isYearlyCard
                  ? "paymentV3.summary.freq.perYear"
                  : "paymentV3.summary.freq.perMonth"
              )}
            </span>
            {active && (
              <span className="paymentV3FreqCards__check">
                <GlobalIcon iconName="CheckedIcon" size="XS" color="#FFFFFF" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default FreqCards;
